import React from 'react';
import InboundHeader from './InboundHeader';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

const InboundLayout = () => (
  <Box position="relative">
    <InboundHeader />
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        pt: '60px',
      }}
    >
      <Outlet />
    </Box>
  </Box>
);

export default InboundLayout;